// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldIcon, FormFieldStyle } from "@vanmeter/MobiusOverrides/FormField";
import { searchInputStyles } from "@vanmeter/Overrides/Widgets/Header/SearchInput";
import { color, styledScrollbar, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

searchInputStyles.inputWrapper = {
    css: css`
        line-height: 0; // to fix extra spacing on firefox
        width: 100%;
        display: flex;
        gap: 16px;
        align-items: center;

        & > ${FormFieldStyle} .search-input {
            ${({ hasValue }: any) =>
            hasValue &&
            css`
                    &,
                    &:focus {
                        padding-right: 65px;
                    }
                `}
        }
    `,
};

searchInputStyles.input = {
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            ${FormFieldIcon} {
                padding: 0;
                justify-content: center;
            }
            &:not(:has(.is-mobile-search)) {
                .clickable-wrapper {
                    right: 48px;
                    max-height: 44px;
                }
            }
            ${xScreen("lte", "xs")} {
                .clickable-wrapper:not(:empty) {
                    height: 33px;
                    top: 1px;
                    right: 1px;
                }
            }
            .end-adornment {
                height: 100%;
                button {
                    margin-top: 1px;
                    height: calc(100% - 1px);
                }
            }
        `,
        inputSelect: css`
            &:not(.is-mobile-search) {
                height: 44px;
            }

            &:focus {
                border-color: ${color("common.ui5")};
            }
        `,
    },
};

searchInputStyles.searchButton = {
    variant: "tertiary",
    css: css`
        width: 42px;
        height: 42px;
        padding: 0;
        border-radius: 0;
    `,
};

searchInputStyles.searchPopUpWrapper = {
    css: css`
        ${({ width }: any) => css`
            width: ${width}px;
        `}

        ${xScreen("lte", "md")} {
            width: 100vw;
            height: 100vh;
            height: 100svh;
        }
    `,
};

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        max-height: calc(100vh - var(--headerHeight));
        max-height: calc(100svh - var(--headerHeight));

        width: 100%;
        overflow: hidden;

        ${({ width }: any) =>
            width &&
            css`
                width: ${width}px;
            `}

        ${xScreen("lte", "md")} {
            width: 100vw;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            ${styledScrollbar()}
        }
    `,
};

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        padding: 0 8px;
        height: 100%;
        margin-top: 8px;
        ${styledScrollbar()}

        ${xScreen("lte", "sm")} {
            border-top: 1px solid ${color("common.border")};
            padding-top: 24px;
            margin-top: 0;
        }

        > h5:not(:first-of-type) {
            margin-top: 14px;
        }
    `,
};

searchInputStyles.autocompleteProductsColumn = {
    css: css`
        padding: 4px;
        width: 100%;

        &:has(.has-content) {
            border-left: 1px solid ${color("common.border")};
            width: 50%;
            ${xScreen("lte", "sm")} {
                width: 100%;
                border-left: 0;
            }
        }
    `,
};

searchInputStyles.autocompleteLeftColumn = {
    css: css`
        padding: 4px;
        width: 50%;
        ${xScreen("lte", "sm")} {
            width: 100%;
            order: 2;
            padding-top: 0;
        }
    `,
};

searchInputStyles.autocompleteColumnProductWrapper = {
    css: css`
        padding: 8px;
        height: 100%;
        ${styledScrollbar()}

        &:not(.has-content) {
            ${({ width }: any) => css`
                width: ${width}px;
                ${xScreen("lte", "md")} {
                    width: 100%;
                }
            `}
        }
    `,
};

searchInputStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            border: 1px solid ${color("common.border")};
            box-shadow: unset;
            padding: 0;
            max-width: 100vw;
            border-radius: 0;
            overflow: hidden;
            &:empty {
                border: none;
            }
            ${xScreen("lte", "md")} {
                border: none;
            }
        `,
    },
};

searchInputStyles.mobileSearchWrapper = {
    css: css`
        width: 100vw;
        height: 100vh;
        height: 100svh;
        display: flex;
        justify-content: center;
    `,
};

searchInputStyles.mobileSearchBackButton = {
    variant: "link" as any,
    color: "common.ui5",
};
